import { render, staticRenderFns } from "./RSsserviceManage.vue?vue&type=template&id=4f0de6d8&scoped=true"
import script from "./RSsserviceManage.vue?vue&type=script&lang=js"
export * from "./RSsserviceManage.vue?vue&type=script&lang=js"
import style0 from "./RSsserviceManage.vue?vue&type=style&index=0&id=4f0de6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0de6d8",
  null
  
)

export default component.exports